import React, { useContext, useEffect } from "react";
import BackToTop from "./components/BackToTop";
import ContactForm from "./components/ContactForm";
import ErrorBoundary from "./components/ErrorBoundary";
import Experience from "./components/Experience";
import Footer from "./components/Footer";
import Header from "./components/Header";
import JourneyScene from "./components/JourneyScene";
import Projects from "./components/Projects";
import Research from "./components/Research";
import SiteNavigation from "./components/SiteNavigation";
import Skills from "./components/Skills";
import Testimonials from "./components/Testimonials";
import { ThemeContext } from "./components/ThemeContext";
import { logPageVisit } from "./utils/eventLogger";
import "./App.css";
import "./DesignSystem.css";

function App() {
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    document.body.className = theme === "light" ? "light-theme" : "dark-theme";
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  useEffect(() => {
    logPageVisit();
  }, []);

  return (
    <ErrorBoundary>
      <div className="portfolio-app">
        <JourneyScene theme={theme} />
        <SiteNavigation />
        <Header />
        <main className="portfolio-main">
          <Experience />
          <Research />
          <Projects />
          <Skills />
          <Testimonials />
          <ContactForm />
        </main>
        <BackToTop />
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
